import React from 'react';
import './Dashboard.scss';
import { Statistic, Row, Col } from 'antd';
import { Link } from "react-router-dom";

const Dashboard = () => {
    return (
        <div class="admin-dashboard">
            <div class="admin-dashboard">
                <Row>
                    <Col span={24} id="total">
                        <Statistic title="Total Users" value={110} >
                            <Link href="./TotalUsers" />
                        </Statistic>
                    </Col>
                </Row>
                <Row>
                    <Col span={12} id="active">
                        <Statistic title="Not Activated Users" value={30} />
                    </Col>
                    <Col span={12} id="inactive">
                        <Statistic title="Activated Users" value={80} />
                    </Col>
                </Row>
                <Row>
                    <Col span={12} id="started">
                        <Statistic title="Users Started Chapters" value={80} />
                    </Col>
                    <Col span={12} id="completed">
                        <Statistic title="Users Completed Course" value={54} />
                    </Col>
                </Row>
            </div>
            <div class="total">

            </div>
        </div>
    )
}

export default Dashboard